// extracted by mini-css-extract-plugin
module.exports = {"price":"styles_price__1n3Gd","blur":"styles_blur__1Gwz4"};